module.exports = __webpack_public_path__ + "static/img/JP.f4601af4.svg";